module.exports = __webpack_public_path__ + "img/banner-4.27a353c3.png";